import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import LrfService from '../../../../services/lrf-auth';
import InfiniteScroll from '../../utils/infiniteScroll';
import Lrf from './lrf';


const ListarLrf = () => {

    async function fetchLrf() {
        await seraQueAcabou();
        const response = await LrfService.listar({ limit: true, cod_lrf: cod });
        if (response.data.length >= 1) {
            let count = Math.floor(numLrf / 20) + 1
            for (let i = 1; i < count; i++) {
                setLrfs([...lrfs, ...response.data])
                setCod(response.data[response.data.length-1]["cod_lrf"])
                if (response.data.length < 20) {
                    setAindaTem(false)
                }
            }
        } else {
            setLrfs([])
            setVazio(true)
        }
    }

    const [lrfs, setLrfs] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [lrf, setLrf] = useState("");
    const [cod, setCod] = useState(null);
    const [numLrf, setNumLrf] = useState(null);
    const [aindaTem, setAindaTem] = useState(true);



    async function fetchLrfIn() {
        await pegaNumLrf();
        const response = await LrfService.listar({ limit: true });
        if (response.data.length >= 1) {
            setLrfs(response.data)
            setVazio(false)
            setCod(response.data[response.data.length-1]["cod_lrf"])
            if (response.data.length == 20) {
                setAindaTem(true)
            } else {
                setAindaTem(false)
            }
        } else {
            setLrfs([])
            setVazio(true)
        }
    }

    async function pegaNumLrf() {
        const response = await LrfService.numLrf({ todas: true })
        setNumLrf(parseInt(response.data))
    }

    const seraQueAcabou = async () => {
        if (lrfs.length >= numLrf + 1) {
            setAindaTem(false)
        } else {
            setAindaTem(true)
        }
    }

    const handleEditar = (id) => {
        setLrf(id);
        setEditar(true)
    }

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a LRF?')) {
            await LrfService.deletar(id)
            alert("LRF deletada com sucesso!")
            fetchLrf();
        }
    }

    useEffect(() => {
        fetchLrfIn();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/lrf/editar/${lrf}`} />
        )
    } 
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setLrfs={setLrfs}
                        setVazio={setVazio}
                        setAindaTem={setAindaTem}
                        fetchLrfIn={fetchLrfIn}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={4}>
                            {lrfs.map((lrf, index) =>
                                <Lrf
                                    fetchLrfIn={fetchLrfIn}
                                    lrf={lrf}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                        {aindaTem ?
                            <Fragment>
                                <p>Carregando mais LRF's...</p>
                                <InfiniteScroll Listar={fetchLrf} />
                            </Fragment>
                            : <p>Todas LRF's já foram exibidas :)</p>}
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarLrf;